import { CrmEffects } from '@zayan-erp/stores';

export const appEffects = [CrmEffects];
